<header class="modal-header header">
  <span class="modal-title">{{ Localization.MakeMultipleCopies | translate }}</span>
</header>
<main class="modal-body">

  <ng-container *ngIf="isCopying; then copyProgressView else formView"></ng-container>

  <ng-template #copyProgressView>
    <p>{{ Localization.DuplicationMessage | translate: { original: originalName } }}</p>
    <small class="text-muted text-right">{{ Localization.DuplicationProgressMessage | translate: { current: copiesMade, total: desiredAmountOfCopies } }}</small>
    <mdb-progress-bar [mode]="'determinate'"
                      [value]="progress"></mdb-progress-bar>

  </ng-template>

  <ng-template #formView>
    <p>{{ Localization.NumberOfCopiesQuestion | translate: { original: originalName } }}</p>

    <chapps-number-input [label]="Localization.NumberOfCopies"
                         [control]="amountField"></chapps-number-input>

    <small class="alert alert-warning my-3"
           *ngIf="showPerformanceWarning"
          [innerHTML]="Localization.DuplicationPerformanceWarning | translate"></small>
  </ng-template>

</main>
<footer class="modal-footer footer">
  <chapps-secondary-button [label]="Localization.Cancel"
                           [small]="true"
                           [outline]="true"
                           (click)="cancel()"></chapps-secondary-button>
  <chapps-secondary-button [label]="Localization.Duplicate"
                           [small]="true"
                           [loading]="isCopying"
                           [disabled]="isCopying"
                           (click)="duplicate()"></chapps-secondary-button>
</footer>
